import React from 'react';
import { PDFDocument } from 'pdf-lib';

const SplitPDF = () => {
  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const arrayBuffer = await file.arrayBuffer();
    const pdfDoc = await PDFDocument.load(arrayBuffer);
    const totalPages = pdfDoc.getPageCount();

    for (let i = 0; i < totalPages; i++) {
      const newPdf = await PDFDocument.create();
      const [copiedPage] = await newPdf.copyPages(pdfDoc, [i]);
      newPdf.addPage(copiedPage);

      // try to draw a border on the single page PDF
      try {
        const page = newPdf.getPage(0);
        const { width, height } = page.getSize();
        const borderMargin = 10;
        page.drawRectangle({
          x: borderMargin / 2,
          y: borderMargin / 2,
          width: width - borderMargin,
          height: height - borderMargin,
          borderColor: undefined,
          borderWidth: 0.5,
        });
      } catch (e) {
        // ignore if not supported
      }

      const pdfBytes = await newPdf.save();
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });

      // Download each page
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `page-${i + 1}.pdf`;
      link.click();
    }
  };

  return (
    <div>
      <div style={{ padding: 16, border: '1px solid #e0e0e0', borderRadius: 6 }}>
        <h3>Split PDF into Pages</h3>
        <input id="split-upload" type="file" accept="application/pdf" onChange={handleFileUpload} style={{display:'none'}} />
        <label htmlFor="split-upload" className="tool-button"><svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4v16"/><path d="M20 4v16"/><path d="M12 4v16" strokeDasharray="4 2"/></svg> Upload & Split</label>
      </div>

      <div className="content">

  <h2>Split PDF: Extract Pages and Create New, Organized Documents</h2>

  <p>
    Large PDF files can be difficult to navigate, share, or organize—especially when 
    you only need specific pages. The Split PDF tool helps you extract pages, divide 
    documents into multiple parts, or break down a large file into smaller, more 
    manageable PDFs.
  </p>

  <p>
    Whether you're preparing project sections, sharing only the required pages, or 
    reorganizing your personal files, splitting a PDF has never been easier.
  </p>

  <h3>Why Split a PDF?</h3>

  <ul>
    <li>Extract only the pages you need</li>
    <li>Reduce large documents into smaller chunks</li>
    <li>Create separate PDFs for different sections</li>
    <li>Share specific pages without exposing the full document</li>
    <li>Organize reports, contracts, scans, or study materials</li>
  </ul>

  <h3>How the Split PDF Process Works</h3>

  <h4>1. Upload Your PDF File</h4>
  <p>
    Start by selecting the PDF you want to split. The tool securely loads the file 
    and displays the total number of pages.
  </p>

  <h4>2. Choose How You Want to Split</h4>
  <p>
    You can split the document in several ways:
  </p>
  <ul>
    <li><strong>By specific page numbers</strong> – Enter page ranges like 1–3, 5–7, etc.</li>
    <li><strong>Extract single pages</strong> – Select any page you want to save separately.</li>
    <li><strong>Split evenly</strong> – Divide the PDF into equal parts automatically.</li>
    <li><strong>One page per file</strong> – Convert every page into its own PDF.</li>
  </ul>

  <h4>3. Process and Generate New PDFs</h4>
  <p>
    Once your preferences are set, the system processes the document and generates 
    new PDF files based on your selections. Each output file is clean, accurate, and 
    preserves the original layout and formatting.
  </p>

  <h3>Your Final Output</h3>
  <p>
    You’ll receive one or more neatly organized PDFs that contain only the content 
    you selected. These files are easy to download, share, or archive, and they open 
    perfectly on any device.
  </p>

</div>

    </div>
  );
};

export default SplitPDF;
